require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-building-a-deep-learning-computer.json") })
        }
      }, "path---posts-building-a-deep-learning-computer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-building-a-deep-learning-computer!./.cache/json/posts-building-a-deep-learning-computer.json
// module id = 371
// module chunks = 231608221292675